/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import currency from "currency.js";
import { CSVLink } from "react-csv";
import { Dropdown, Form } from "react-bootstrap";

import { Helmet } from "react-helmet";
import Topbar from "../topbar/Topbar";
import Sidebar from "../sidebar/Sidebar";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import {
  fetchActionsUtil,
  useCookie,
  stringifyQueryString,
  calenderMonths,
} from "../../utils";
import { DownArrowIcon, SearchIcon, SummaryChartIconUp } from "../icons";
import { Row } from "reactstrap";
import { URLS } from "../urls";
import { toast } from "react-toastify";
import moment from "moment";
import { SummaryCloseIcon } from "../icons";
import { allMonths } from "../../utils";
import { DialogModal } from "../DialogModal";
import { InforModal } from "../InforModal";
import ImportPaylistFromExcel from "../editEmployeeJobGrade/ImportPaylistFromExcel";
import ModalLoader from "../ModalLoader";
import { ExcelIcon, ExportIcon } from "../icons";
import { useDownloadExcel } from "../useDownloadExcel";
import TableComponent from "../TableComponent";
import { UseQueryData } from "../UseQueryData";
import CustomPagination from "../Paginations";
import NoTableItem from "../NoTableItem";
import { CalendarTodayOutlined } from "@mui/icons-material";
import { SalarySetting } from "./SalarySetting";
import { useComputePayroll } from "./UseComputePayroll";

function CreateSalary() {
  const branch_id = useCookie("branch_id");
  const date = new Date();
  const [payrollDate, setPayrollDate] = useState({
    payrollMonth: "",
    payrollYear: date.getFullYear(),
  });

  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 20,
    page: 1,
    id: "",
    name: "",
    category: "",
    type: "All",
    department: "",
    grades: "",
    sortBy: "id",
    sortOrder: "asc",
  };
  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });
  // ------------------ Filter Search -------------------//

  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [dialog] = useState("send-payroll");
  const [openDialog, setOpenDialog] = useState(false);
  const [openInforDialog, setOpenInforDialog] = useState(false);
  const [useExcel, setUseExcel] = useState("");
  const [theexcelData, settheexcelData] = useState([]);
  const [btnText, setBtnText] = useState("Process Payroll");
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [excelName, setExcelName] = useState("Salary Computation");
  const [progressData, setProgressData] = useState({
    text: "",
    progress: 0,
  });

  const [excelData, setExcelData] = useState([]);

  const CSVLinkRef = useRef(null);

  // // fetch excel hook
  const [isfetchingExcel] = useDownloadExcel(excelData, CSVLinkRef);

  const {
    normalEmployees,
    searchItems,
    IsFetching,
    settingHeaders,
    returnParams,
    totalbenefit,
    totalallowance,
    totalbonus,
    totalGross,
    totalDeduct,
    totalNet,
    companySettings,
    deductionSettings,
    bonusSettings,
    allownaceSettings,
    benefitSettings,
    pendingRetirement,
    customHeaders,
    DeductionGroupName,
    BonusGroupName,
    AllowanceGroupName,
    BenefitGroupName,
    payrollSetting,
    payrollCycle,
    calculateEmployeePayroll,
    setNormalEmployees,
  } = useComputePayroll({
    payrollDate,
    queryParams,
    theQueryParams,
    useExcel,
    theexcelData,
  });

  const setRemark = ({ e, employeeId }) => {
    const index = normalEmployees.findIndex(
      (employee) => employee.employeeId === employeeId
    );
    const employee = normalEmployees[index];

    normalEmployees[index] = {
      ...employee,
      remark: e.target.value,
    };
    setNormalEmployees([...normalEmployees]);
  };

  const savePayroll = async () => {
    try {
      setBtnText("Processing...");
      setIsSendLoading(true);
      setOpenDialog(false);

      const { type, sortBy, sortOrder, category } = theQueryParams;
      const fullQuery = { type, sortBy, sortOrder, category };

      let mainEmployees = [];

      if (useExcel !== "Use Timesheet") {
        const res = await fetchActionsUtil(
          `${
            URLS.backendPayroll
          }/get-employees/${branch_id}?${stringifyQueryString(
            fullQuery
          )}&date=${payrollDate?.payrollYear}-${payrollDate?.payrollMonth}-1`
        );
        mainEmployees = res?.employees || [];
      } else {
        mainEmployees = theexcelData;
      }

      if (!mainEmployees.length) {
        toast.error("No employees found for payroll.", {
          position: "top-right",
        });
        return;
      }

      // Calculate payroll
      const processedEmployees = await calculateEmployeePayroll(mainEmployees);
      const chunkSize = 100; // Not more than 100
      const totalChunks = Math.ceil(processedEmployees.length / chunkSize);
      const startTime = performance.now();
      let processedCount = 0;
      const totalCount = processedEmployees.length;

      for (let i = 0; i < totalCount; i += chunkSize) {
        try {
          const chunk = processedEmployees.slice(i, i + chunkSize);
          processedCount += chunk.length;

          // Optional: Update UI for each chunk
          const progress = Math.floor((processedCount / totalCount) * 100);
          const duration = ((performance.now() - startTime) / 1000).toFixed(2);
          setProgressData({
            progress,
            text: `Processing ${
              i / chunkSize + 1
            } of ${totalChunks} in (${duration}s)...`,
          });

          const enriched = chunk.map((emp) => ({
            ...emp,
            payrollMonth: payrollDate.payrollMonth,
            payrollYear: payrollDate.payrollYear,
            debitAccountNo: companySettings?.debitAccountNumber,
            debitBankCode: companySettings?.debitBankCode,
            type: "normal",
            settingHeaders,
          }));

          const payload = {
            payroll: enriched,
            payrollMonth: payrollDate.payrollMonth,
            payrollYear: payrollDate.payrollYear,
            companySettings,
            branch_id,
            employeeType: type,
            category,
          };

          const formData = new FormData();
          formData.append("payload", JSON.stringify(payload));

          const response = await fetch(
            `${URLS.backendPayroll}/save-payroll-by-branch`,
            {
              method: "POST",
              body: formData,
            }
          );

          if (!response.ok) {
            const errorText = await response.json();
            throw new Error(errorText?.message || `Payroll processing error!`);
          }
        } catch (error) {
          throw new Error(`${error || "Payroll processing error!"}`);
        }
      }

      const duration = ((performance.now() - startTime) / 1000).toFixed(2);
      toast.success(`✅ Payroll successfully created in (${duration}s)`, {
        position: "top-right",
      });
      setOpenInforDialog(true);
    } catch (error) {
      console.error(error);
      toast.error(`❌🛑 ${error || "Payroll processing error!"}`, {
        position: "top-right",
      });
    } finally {
      setBtnText("Process");
      setIsSendLoading(false);
      setProgressData({
        progress: 0,
        text: "",
      });
    }
  };

  const onDownloadExcelData = async () => {
    setExcelName("Salary Computation");
    let exData = normalEmployees.map((employee, index) => [
      index + 1,
      employee.name.first + " " + employee.name.last,
      employee.employeeId,
      useExcel === "Use Timesheet" ? employee?.sfa_id : "",
      employee.gradeName,
      employee?.totalDaysWorked || 0,
      companySettings?.extras
        ? employee?.userExtras?.DayOn === ""
          ? 0
          : employee?.userExtras?.DayOn
        : "",

      companySettings?.extras
        ? employee?.userExtras?.TransitDays === ""
          ? 0
          : employee?.userExtras?.TransitDays
        : "",

      companySettings?.extras
        ? employee?.userExtras?.OverStayDays === ""
          ? 0
          : employee?.userExtras?.OverStayDays
        : "",

      companySettings?.extras
        ? employee?.userExtras?.ArrearsDays === ""
          ? 0
          : employee?.userExtras?.ArrearsDays
        : "",

      employee.usedlocation,
      employee.usedcontract,
      useExcel === "Use Timesheet" ? employee?.totalDaysWorked : "",
      useExcel === "Use Timesheet"
        ? parseFloat(employee?.numProration).toFixed(2)
        : "",
      currency(employee.grossPay, {
        symbol: "",
      }).format(),
      currency(employee.basic, {
        symbol: "",
      }).format(),
      currency(employee.housing, {
        symbol: "",
      }).format(),
      currency(employee.transport, {
        symbol: "",
      }).format(),
      currency(employee.medical, {
        symbol: "",
      }).format(),
      currency(employee.utility, {
        symbol: "",
      }).format(),
      currency(employee.entertainment, {
        symbol: "",
      }).format(),
      currency(employee.dressing, {
        symbol: "",
      }).format(),
      ...employee?.custom?.map((el) =>
        currency(el?.value, {
          symbol: "",
        }).format()
      ),
      currency(employee.ogGrossPay, {
        symbol: "",
      }).format(),

      ...deductionSettings
        .filter((el) => !el.groupName)
        .map((e, i) => {
          return currency(
            employee.deductions.find((el) => el.slug === e.slug)?.total,
            {
              symbol: "",
            }
          ).format();
        }),

      ...employee.DeductionGroupName.map((e, i) =>
        currency(
          employee.deductions
            ?.filter((el) => el.groupName === e)
            .map((el) => el.total)
            .reduce((a, b) => a + b, 0),
          {
            symbol: "",
          }
        ).format()
      ),

      ...bonusSettings
        .filter((el) => !el.groupName)
        .map((e, i) => {
          return currency(
            employee.bonus.find((el) => el.slug === e.slug)?.total,
            {
              symbol: "",
            }
          ).format();
        }),

      ...employee.BonusGroupName.map((e, i) =>
        currency(
          employee.bonus
            ?.filter((el) => el.groupName === e)
            .map((el) => el.total)
            .reduce((a, b) => a + b, 0),
          {
            symbol: "",
          }
        ).format()
      ),

      ...allownaceSettings
        .filter((el) => !el.groupName)
        .map((e, i) => {
          return currency(
            employee.allowances.find((el) => el.slug === e.slug)?.total,
            {
              symbol: "",
            }
          ).format();
        }),

      ...employee.AllowanceGroupName.map((e, i) =>
        currency(
          employee.allowances
            ?.filter((el) => el.groupName === e)
            .map((el) => el.total)
            .reduce((a, b) => a + b, 0),
          {
            symbol: "",
          }
        ).format()
      ),

      ...benefitSettings
        .filter((el) => !el.groupName)
        .map((e, i) => {
          return currency(
            employee.benefits.find((el) => el.slug === e.slug)?.total,
            {
              symbol: "",
            }
          ).format();
        }),

      ...employee.BenefitGroupName.map((e, i) =>
        currency(
          employee.benefits
            ?.filter((el) => el.groupName === e)
            .map((el) => el.total)
            .reduce((a, b) => a + b, 0),
          {
            symbol: "",
          }
        ).format()
      ),

      employee.loanDeduct
        ? currency(employee.loanDeduct, {
            symbol: "",
          }).format()
        : 0,
      pendingRetirement.length > 0 && employee.remainingRetairment
        ? currency(employee.remainingRetairment, {
            symbol: "",
          }).format()
        : 0,
      currency(employee.attendanceTotal, {
        symbol: "",
      }).format(),
      currency(employee.allTotalDeduction, {
        symbol: "",
      }).format(),
      currency(employee.totalBonus, {
        symbol: "",
      }).format(),
      currency(employee.totalAllowances, {
        symbol: "",
      }).format(),
      currency(employee.totalBenefits, {
        symbol: "",
      }).format(),
      currency(employee.netPay, {
        symbol: "",
      }).format(),
    ]);

    const normalHead = [
      "No",
      "Name",
      "Employees ID",
      "SFA ID",
      "Job Grade",
      "Days Committed",
      companySettings?.extras ? "Days On" : "",
      companySettings?.extras ? "Transit Days" : "",
      companySettings?.extras ? "Overstay Days" : "",
      companySettings?.extras ? "Arrears Days" : "",
      "Location",
      "LSP",
      "Days Worked",
      "Proration",
      "Gross Salary",
      "Basic",
      "Housing",
      "Transport",
      "Medical",
      "Utility",
      "Entertainment",
      "Dressing",
      ...customHeaders.map((el) => el),
      "Earned Gross Salary",

      ...deductionSettings
        .filter((el) => !el.groupName)
        .map((setting, index) => {
          return setting.name;
        }),

      ...DeductionGroupName.map((setting, index) => setting),

      ...bonusSettings
        .filter((el) => !el.groupName)
        .map((setting, index) => {
          return setting.name;
        }),

      ...BonusGroupName.map((setting, index) => setting),

      ...allownaceSettings
        .filter((el) => !el.groupName)
        .map((setting, index) => {
          return setting.name;
        }),

      ...AllowanceGroupName.map((setting, index) => setting),

      ...benefitSettings
        .filter((el) => !el.groupName)
        .map((setting, index) => {
          return setting.name;
        }),

      ...BenefitGroupName.map((setting, index) => setting),

      "Loan Deductions",
      "IOU Deductions",
      "Attendance Deduction",
      "Total Deductions",
      "Total Bonus",
      "Total Allowance",
      "Total Benefit",
      "Net Pay",
    ];

    const date = `Date Prepared: ${moment(new Date()).format(
      "MMMM DD yyyy k:mm:ss z"
    )}`;

    exData = [
      // [company],
      ["Payroll Report"],
      [date],
      [""],
      normalHead,
      ...exData,
      [""],
      ["Payroll Summary"],
      [
        "Total Earned Gross",
        currency(totalGross, {
          symbol: "",
        }).format(),
      ],
      [
        "Total Allowance",
        currency(totalallowance, {
          symbol: "",
        }).format(),
      ],
      [
        "Total Benefit",
        currency(totalbenefit, {
          symbol: "",
        }).format(),
      ],
      [
        "Total Bouns",
        currency(totalbonus, {
          symbol: "",
        }).format(),
      ],

      [
        "Total Deduction",
        currency(totalDeduct, {
          symbol: "",
        }).format(),
      ],
      [
        "Total Net Amount",
        currency(totalNet, {
          symbol: "",
        }).format(),
      ],
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  const onDownloadExcelPayeeTax = async () => {
    setExcelName("PayE Tax Computation");

    let taxNames = [];

    const computation = payrollSetting?.taxRateAsPerMonthlyComputation.sort(
      (a, b) => a.ratePercentage - b.ratePercentage
    );

    let exData = normalEmployees.map((employee, index) => {
      let totalExemption = [];
      if (payrollSetting?.exemptionDeductions?.length > 0) {
        totalExemption = employee?.deductions?.filter(({ _id }) =>
          payrollSetting?.exemptionDeductions?.find((ele) => _id === ele)
        );

        totalExemption = totalExemption?.map((el) => ({
          amount: el?.total,
          name: el?.groupName,
        }));

        taxNames = totalExemption;
      }

      const computationTax = employee?.taxRateArray?.sort(
        (a, b) => a.percent - b.percent
      );

      // console.log({ taxNames, totalExemption });

      return [
        index + 1,
        employee.name.first + " " + employee.name.last,
        employee.employeeId,
        useExcel === "Use Timesheet" ? employee?.sfa_id : "",
        employee.gradeName,
        currency(employee.grossPay, {
          symbol: "",
        }).format(),
        currency(employee.basic, {
          symbol: "",
        }).format(),
        currency(employee.housing, {
          symbol: "",
        }).format(),
        currency(employee.transport, {
          symbol: "",
        }).format(),
        currency(employee.medical, {
          symbol: "",
        }).format(),
        currency(employee.utility, {
          symbol: "",
        }).format(),
        currency(employee.entertainment, {
          symbol: "",
        }).format(),
        currency(employee.dressing, {
          symbol: "",
        }).format(),
        ...employee?.custom?.map((el) =>
          currency(el?.value, {
            symbol: "",
          }).format()
        ),
        currency(employee.ogGrossPay, {
          symbol: "",
        }).format(),

        ...totalExemption?.map((el) =>
          currency(el?.amount, {
            symbol: "",
          }).format()
        ),
        currency(employee?.totalExemption, {
          symbol: "",
        }).format(),
        currency(employee?.CRAGrossPurpose, {
          symbol: "",
        }).format(),
        currency(employee?.CRAGrossPurposePercentage, {
          symbol: "",
        }).format(),
        currency(employee?.personalAllowance, {
          symbol: "",
        }).format(),
        currency(employee?.totalRelief, {
          symbol: "",
        }).format(),
        currency(employee?.totalExemption, {
          symbol: "",
        }).format(),
        currency(employee?.chargeableIncome, {
          symbol: "",
        }).format(),
        ...computationTax.map((ele, i) =>
          currency(ele?.amount, {
            symbol: "",
          }).format()
        ),
        currency(employee?.taxRateAsPerMonthlyTotal, {
          symbol: "",
        }).format(),
      ];
    });

    const normalHead = [
      "No",
      "Name",
      "Employees ID",
      "SFA ID",
      "Job Grade",
      "Gross Salary",
      "Basic",
      "Housing",
      "Transport",
      "Medical",
      "Utility",
      "Entertainment",
      "Dressing",
      ...customHeaders.map((el) => el),
      "Earned Gross Salary",
      ...taxNames.map((el) => el?.name),
      "Total Exempt",
      "Gross For CRA Purpose",
      `Gross For CRA Purpose (${payrollSetting?.grossForCraPurposePercentage}%)`,
      `Personal Allowance ${payrollSetting?.personalAllowance}/PA`,
      "Total Relief",
      "Total Deductions",
      "Chargeble Income",
    ];

    const date = `Date Prepared: ${moment(new Date()).format(
      "MMMM DD yyyy k:mm:ss z"
    )}`;

    exData = [
      // [company],
      ["Paye Tax Computation"],
      [date],
      [""],
      [
        ...normalHead?.map((ele) => ""),
        ...computation.map((el) => `${el?.ratePercentage}%`),
      ],
      [
        ...normalHead,
        ...computation.map((el) =>
          currency(el?.rateAmount, {
            symbol: "",
          }).format()
        ),
        "TAX PAYABLE",
      ],
      ...exData,
      [""],
    ];

    // console.log(exData);
    setExcelData(exData);
  };

  const tableHead = () => {
    const shouldShow = (field) =>
      Object.keys(settingHeaders).length === 0 || settingHeaders[field];

    const renderHeaderCells = (arr, isGroup = false) =>
      arr?.map((item, idx) => (
        <th className="text-capitalize" key={`${item}-${idx}`}>
          {isGroup ? (
            <>
              {item}
              <br />
            </>
          ) : item.name === "company pension" ? (
            "Employer pension contribution"
          ) : item.name === "pension" ? (
            "Employee pension contribution"
          ) : (
            item.name
          )}
          {!isGroup ? (
            <>
              <SalarySetting setting={item} />
              <br />
            </>
          ) : null}
        </th>
      ));

    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>No</th>
          <th>Name</th>
          <th>Employees ID</th>
          {useExcel === "Use Timesheet" && <th>SFA ID</th>}
          <th>Job Grade</th>
          <th>Join Date</th>
          <th>Days Committed</th>
          {companySettings?.extras ? (
            <>
              <th>Days On</th>
              <th>Transit Days</th>
              <th>Overstay Days</th>
              <th>Arrears Days</th>
            </>
          ) : null}

          <th>Location</th>
          <th>LSP</th>
          {useExcel === "Use Timesheet" && (
            <>
              <th>Proration</th>
            </>
          )}
          <th>Gross Salary</th>
          {shouldShow("basic") && <th>Basic</th>}
          {shouldShow("housing") && <th>Housing</th>}
          {shouldShow("transport") && <th>Transport</th>}
          {shouldShow("medical") && <th>Medical</th>}
          {shouldShow("utility") && <th>Utility</th>}
          {shouldShow("entertainment") && <th>Entertainment</th>}
          {shouldShow("dressing") && <th>Dressing</th>}

          {customHeaders.map((el, i) => (
            <th key={`custom-${i}`}>{el}</th>
          ))}
          <th>Earned Gross Salary</th>

          {/* Deductions */}
          {renderHeaderCells(deductionSettings?.filter((d) => !d.groupName))}
          {renderHeaderCells(DeductionGroupName || [], true)}

          {/* Bonuses */}
          {renderHeaderCells(bonusSettings?.filter((b) => !b.groupName))}
          {renderHeaderCells(BonusGroupName || [], true)}

          {/* Allowances */}
          {renderHeaderCells(allownaceSettings?.filter((a) => !a.groupName))}
          {renderHeaderCells(AllowanceGroupName || [], true)}

          {/* Benefits */}
          {renderHeaderCells(benefitSettings?.filter((b) => !b.groupName))}
          {renderHeaderCells(BenefitGroupName || [], true)}

          <th>Loan Deductions</th>
          {pendingRetirement?.length > 0 && <th>IOU Deductions</th>}
          <th>Attendance Deduction</th>
          <th>Total Deductions</th>
          <th>Total Bonus</th>
          <th>Total Allowance</th>
          <th>Total Benefit</th>
          <th>Remark</th>
          <th>Net Pay</th>
        </tr>
      </thead>
    );
  };

  const tableBodyData = (employee, index) => {
    const {
      name,
      employeeId,
      sfa_id,
      gradeName,
      startDate,
      totalDaysWorked = 0,
      userExtras = {},
      usedlocation,
      usedcontract,
      numProration,
      grossPay,
      custom = [],
      ogGrossPay,
      deductions = [],
      bonus = [],
      allowances = [],
      benefits = [],
      loanDeduct,
      remainingRetairment,
      attendanceTotal,
      allTotalDeduction,
      totalBonus,
      totalAllowances,
      totalBenefits,
      remark,
      netPay,
    } = employee;

    const extras = companySettings?.extras;
    const noHeaders = Object.keys(settingHeaders).length === 0;

    const formatCur = (val) => currency(val || 0, { symbol: "" }).format();

    const renderGroupSum = (data, groupName) =>
      formatCur(
        data
          .filter((el) => el.groupName === groupName)
          .reduce((acc, el) => acc + (el.total || 0), 0)
      );

    const renderSlug = (data, slug) =>
      formatCur(data.find((el) => el.slug === slug)?.total);

    const currencyCell = (val) => (
      <td>{currency(val || 0, { symbol: "" }).format()}</td>
    );

    const ungroupedCells = (settings, data) =>
      settings
        .filter((el) => !el.groupName)
        .map((e, i) => <td key={`type-${i}`}>{renderSlug(data, e.slug)}</td>);

    const groupCells = (groupNames, data) =>
      groupNames.map((name, i) => (
        <td key={`group-${i}`}>{renderGroupSum(data, name)}</td>
      ));

    return (
      <>
        <td>{returnParams?.startIndex + index + 1}</td>
        <td>{`${name?.first || ""} ${name?.last || ""}`}</td>
        <td>{employeeId}</td>
        {useExcel === "Use Timesheet" && <td>{sfa_id}</td>}
        <td>{gradeName}</td>

        <td className="d-flex gap-3 align-items-baseline">
          <span>
            <CalendarTodayOutlined fontSize="small" />
          </span>
          <p>{moment(startDate, "DD/MM/YYYY").format("Do MMMM YYYY")}</p>
        </td>

        <td>{totalDaysWorked || 0}</td>

        {extras && (
          <>
            <td>{userExtras.DayOn || 0}</td>
            <td>{userExtras.TransitDays || 0}</td>
            <td>{userExtras.OverStayDays || 0}</td>
            <td>{userExtras.ArrearsDays || 0}</td>
          </>
        )}

        <td>{usedlocation}</td>
        <td>{usedcontract}</td>

        {useExcel === "Use Timesheet" && (
          <td>{parseFloat(numProration || 0).toFixed(2)}</td>
        )}

        <td>{formatCur(grossPay)}</td>

        {[
          "basic",
          "housing",
          "transport",
          "medical",
          "utility",
          "entertainment",
          "dressing",
        ].map(
          (key) =>
            (noHeaders || settingHeaders[key]) && currencyCell(employee[key])
        )}

        {custom.map((el, i) => (
          <td key={`custom-${i}`}>{formatCur(el?.value)}</td>
        ))}

        <td>{formatCur(ogGrossPay)}</td>

        {ungroupedCells(deductionSettings, deductions)}

        {groupCells(DeductionGroupName, deductions)}

        {ungroupedCells(bonusSettings, bonus)}

        {groupCells(BonusGroupName, bonus)}

        {ungroupedCells(allownaceSettings, allowances)}

        {groupCells(AllowanceGroupName, allowances)}

        {ungroupedCells(benefitSettings, benefits)}

        {groupCells(BenefitGroupName, benefits)}

        <td>{loanDeduct ? formatCur(loanDeduct) : 0}</td>

        {pendingRetirement?.length > 0 && (
          <td>{remainingRetairment ? formatCur(remainingRetairment) : 0}</td>
        )}

        <td>{formatCur(attendanceTotal)}</td>
        <td>{formatCur(allTotalDeduction)}</td>
        <td>{formatCur(totalBonus)}</td>
        <td>{formatCur(totalAllowances)}</td>
        <td>{formatCur(totalBenefits)}</td>

        <td>
          <input
            value={remark ?? "..."}
            onClick={(e) => e.target.select()}
            onChange={(e) => setRemark({ e, employeeId })}
            className="form-control payroll-input"
          />
        </td>

        <td>{formatCur(netPay)}</td>
      </>
    );
  };

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="row">
              <div className="col-sm-12 col-12 text-capitalize">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <Link to={`${URLS.dashboard}`}>Dashboard</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>Process Payroll</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <div className="col-sm-5 col-5"></div>
            </div>
            {/*<!-- /Page Title -->*/}
            {/*<!-- Content Starts -->*/}
            <div className="mt-3">
              <div className="d-flex justify-content-between my-4">
                <div className="d-flex">
                  <div className="form-inline">
                    <label>Select Month</label>
                    <select
                      className="form-control mx-2"
                      value={payrollDate.payrollMonth}
                      onChange={(e) =>
                        setPayrollDate({
                          payrollMonth: e.target.value,
                          payrollYear: payrollDate.payrollYear,
                        })
                      }
                    >
                      <option value="">Select Month</option>
                      {calenderMonths().map((e, index) => (
                        <option key={index} value={index + 1}>
                          {e}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-inline ml-3">
                    <label>Select Year</label>
                    <input
                      type="number"
                      style={{ width: "100px" }}
                      className="form-control mx-2"
                      value={payrollDate.payrollYear}
                      onChange={(e) =>
                        setPayrollDate({
                          payrollMonth: payrollDate.payrollMonth,
                          payrollYear: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="d-flex">
                  <div className="d-flex w-100">
                    <select
                      className="form-control mx-4"
                      aria-label="Default select example"
                      value={useExcel}
                      onChange={(e) => setUseExcel(e.target.value)}
                    >
                      {["Use database", "Use Timesheet"].map((a, i) => (
                        <option key={i} value={a}>
                          {a}
                        </option>
                      ))}
                    </select>

                    <div>
                      {useExcel === "Use Timesheet" && (
                        <Dropdown>
                          <Dropdown.Toggle variant="" bsPrefix="">
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            popperConfig={{
                              strategy: "fixed",
                            }}
                            renderOnMount
                            className="text-center"
                          >
                            <Dropdown.Item as="div" className="p-cursor">
                              <ImportPaylistFromExcel
                                payrollMonth={payrollDate.payrollMonth}
                                payrollYear={payrollDate.payrollYear}
                                handleEmployeesToPay={settheexcelData}
                              />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>

                  <div className="mx-4">
                    <CSVLink
                      className="btn print d-none"
                      filename={`${excelName} (${moment(new Date()).format(
                        "DD-MMM-yyyy hh:mm:ss a"
                      )}).csv`}
                      data={excelData}
                      ref={CSVLinkRef}
                    />

                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        <span className="mx-2">Export</span>
                        <ExportIcon color="#008000" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelData}
                          className="p-cursor"
                        >
                          Salary Computation <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelPayeeTax}
                          className="p-cursor"
                        >
                          PayE Tax Computation
                          <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="w-100">
                    <button
                      onClick={() => setBtnSummaryActive(!btnSummryActive)}
                      className="btn summaryBtn "
                    >
                      Show Summary
                    </button>
                  </div>
                </div>
              </div>

              {/* Search */}
              <div className="my-4">
                <div className="grid-cat-1 filter-row">
                  <div className="form-group">
                    <div className="search-area">
                      <SearchIcon color="#94A3B8" />
                      <Form.Control
                        placeholder="Search employee ID"
                        aria-label="Search employee ID"
                        value={theQueryParams.id}
                        name="id"
                        onChange={onChangeInput}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="search-area">
                      <SearchIcon color="#94A3B8" />
                      <Form.Control
                        placeholder="Search employee name"
                        aria-label="Search employee name"
                        value={theQueryParams.name}
                        onChange={onChangeInput}
                        name="name"
                      />
                    </div>
                  </div>
                  <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                    <Form.Control
                      as="select"
                      value={theQueryParams.department}
                      onChange={onChangeInput}
                      name="department"
                    >
                      <option value="">Select Department</option>
                      {searchItems?.department?.length > 0
                        ? searchItems?.department.map((department) => {
                            return (
                              <option value={department.value}>
                                {department.label}
                              </option>
                            );
                          })
                        : null}
                    </Form.Control>
                    <div className=" pr-2">
                      <DownArrowIcon color="#6c757d" />
                    </div>
                  </div>
                  <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                    <Form.Control
                      as="select"
                      value={theQueryParams.grades}
                      onChange={onChangeInput}
                      name="grades"
                    >
                      <option value="">Select Grades</option>
                      {searchItems?.grades?.length > 0
                        ? searchItems?.grades.map((grade) => {
                            return (
                              <option value={grade.value}>{grade.label}</option>
                            );
                          })
                        : null}
                    </Form.Control>
                    <div className=" pr-2">
                      <DownArrowIcon color="#6c757d" />
                    </div>
                  </div>
                  <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                    <Form.Control
                      as="select"
                      value={theQueryParams.category}
                      onChange={onChangeInput}
                      name="category"
                    >
                      <option value="">Select category</option>
                      {searchItems?.category?.length > 0
                        ? searchItems?.category.map((categories) => {
                            return (
                              <option value={categories.value}>
                                {categories.label}
                              </option>
                            );
                          })
                        : null}
                    </Form.Control>
                    <div className=" pr-2">
                      <DownArrowIcon color="#6c757d" />
                    </div>
                  </div>
                  <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                    <Form.Control
                      as="select"
                      value={theQueryParams.type}
                      onChange={onChangeInput}
                      name="type"
                    >
                      <option value="All">Select employee type</option>
                      <option value="staff">Staff</option>
                      <option value="contract">Contract</option>
                    </Form.Control>
                    <div className=" pr-2">
                      <DownArrowIcon color="#6c757d" />
                    </div>
                  </div>
                </div>
              </div>
              {/* //Search Area */}

              {/* Sort Area */}
              <div className="d-flex w-100 my-4">
                <div>
                  <label>Sort By : </label>
                  <Form.Control
                    as="select"
                    value={theQueryParams.sortBy}
                    onChange={onChangeInput}
                    name="sortBy"
                  >
                    <option value="">Sort By</option>
                    {[
                      { value: "id", label: "Employee ID" },
                      { value: "first", label: "First Name" },
                      { value: "last", label: "Last Name" },
                    ].map((sort) => {
                      return <option value={sort.value}>{sort.label}</option>;
                    })}
                  </Form.Control>
                </div>

                <div className="mx-4">
                  <label>Order By : </label>
                  <Form.Control
                    as="select"
                    value={theQueryParams.sortOrder}
                    onChange={onChangeInput}
                    name="sortOrder"
                  >
                    <option value="">Order By</option>
                    {[
                      { value: "asc", label: "Ascending Order" },
                      { value: "desc", label: "Descending Order" },
                    ].map((sort) => {
                      return <option value={sort.value}>{sort.label}</option>;
                    })}
                  </Form.Control>
                </div>
                {payrollDate.payrollMonth ? (
                  <div className="mx-4">
                    <label>{""} </label>
                    <div>
                      <b>
                        Payroll Cycle from{" "}
                        {moment(payrollCycle.payrollStartDate).format(
                          "Do MMMM YYYY"
                        )}{" "}
                        to{" "}
                        {moment(payrollCycle.payrollEndDate).format(
                          "Do MMMM YYYY"
                        )}
                      </b>
                    </div>
                  </div>
                ) : null}
              </div>
              {/* //Sort Area */}

              {IsFetching ? (
                <ModalLoader show={IsFetching} />
              ) : (
                <>
                  {normalEmployees?.length > 0 && payrollDate.payrollMonth ? (
                    <Row className="table-height">
                      <TableComponent
                        responsive
                        striped
                        sticky
                        tableHeadsFunction={tableHead}
                        mainDataArray={normalEmployees}
                        tableDataRowFunction={tableBodyData}
                        className="product-table text-nowrap"
                      />
                    </Row>
                  ) : (
                    <NoTableItem
                      title={
                        payrollDate.payrollMonth
                          ? `No data on ${
                              allMonths[payrollDate.payrollMonth - 1]
                            } ${payrollDate.payrollYear}`
                          : "Please Select the month for payroll"
                      }
                    />
                  )}
                </>
              )}

              <div className="my-4">
                <CustomPagination
                  setQueryParams={setQueryParams}
                  startIndex={returnParams.startIndex}
                  endIndex={returnParams.endIndex}
                  count={returnParams.count}
                  limit={queryParams.limit}
                  page={queryParams.page}
                  dropDownFunction={dropDownFunction}
                />
              </div>

              {payrollDate.payrollMonth ? (
                <div className="mt-2">
                  {/* <div className="my-3">
                  <label>Send Payslip Mail</label>
                  <div
                    className="onoffswitch ml-0"
                    onClick={(e) => {
                      setSettings({
                        ...settings,
                        sendMail: !settings.sendMail,
                      });
                    }}
                  >
                    <input
                      type="checkbox"
                      name="onoffswitch"
                      className="onoffswitch-checkbox"
                      checked={settings.sendMail}
                    />
                    <label className="onoffswitch-label">
                      <span className="onoffswitch-inner"></span>
                      <span className="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div> */}
                  <button
                    class="btn btn-primary my-3"
                    data-toggle="modal"
                    data-target={`#${dialog}`}
                    onClick={() => setOpenDialog(true)}
                  >
                    {btnText}
                  </button>
                </div>
              ) : null}

              <div
                className={
                  btnSummryActive
                    ? `summaryNew border-top open`
                    : `summaryNew border-top`
                }
              >
                <div className="row justify-content-between mt-4">
                  <div className="col">
                    <div className="my-3">
                      <div className="d-flex gap-3 align-items-center mb-4">
                        <h4 className="m-0">Payroll Summary</h4>{" "}
                        <hr className="flex-grow-1 m-0" />
                        {btnSummryActive && (
                          <button
                            onClick={() =>
                              setBtnSummaryActive(!btnSummryActive)
                            }
                            className="btn p-0"
                          >
                            <SummaryCloseIcon />
                          </button>
                        )}
                      </div>

                      <div
                        className="gridCont mb-3 three-col-grid"
                        style={{ gridTemplateRows: "unset" }}
                      >
                        {/*  */}
                        <div className="gridChild gridChildBorderLeftBlue">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalGross, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Earned Gross</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>

                        {/*  */}

                        <div className="gridChild gridChildBorderLeftDarkerGreen">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalallowance, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Allowance</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>
                        {/*  */}

                        <div className="gridChild gridChildBorderLeftDarkerGreen">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalbenefit, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Benefit</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>
                        {/*  */}
                      </div>

                      {/* Secound Order */}

                      <div
                        className="gridCont mb-3 three-col-grid"
                        style={{ gridTemplateRows: "unset" }}
                      >
                        {/*  */}
                        <div className="gridChild gridChildBorderLeftDarkerGreen">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalbonus, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Bouns</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>
                        {/*  */}

                        <div className="gridChild gridChildBorderLeftOrange">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalDeduct, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Deduction</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>
                        {/*  */}

                        <div className="gridChild gridChildBorderLeftDarkerGreen">
                          <div className="gridChildLeft">
                            <p className="gridChld1">
                              {currency(totalNet, {
                                symbol: "",
                              }).format()}
                            </p>
                            <p className="gridChld2">Total Net Amount</p>
                          </div>

                          <div className="gridChildRight">
                            <SummaryChartIconUp />
                            <p>5%</p>
                          </div>
                        </div>
                        {/*  */}
                      </div>
                    </div>
                  </div>
                </div>
                <DialogModal
                  show={openDialog}
                  proceed={savePayroll}
                  handleClose={() => setOpenDialog(false)}
                  title="Process Payroll"
                  description={`Are you sure you want to process payroll for ${
                    allMonths[payrollDate.payrollMonth - 1]
                  } ${payrollDate.payrollYear}`}
                  sendTitle="Proceed"
                />
                {openInforDialog && (
                  <InforModal
                    show={openInforDialog}
                    proceed={savePayroll}
                    handleClose={() => setOpenInforDialog(false)}
                    description={`${allMonths[payrollDate.payrollMonth - 1]} ${
                      payrollDate.payrollYear
                    } process successfully`}
                    sendTitle="Salary Schedule"
                    link={`/dashboard/salary-summary?month=${payrollDate.payrollMonth}`}
                    secondLink={`/dashboard/pay-history?month=${payrollDate.payrollMonth}`}
                    secondTitle="Payroll History"
                    payrollDate={payrollDate}
                    employeeType={theQueryParams.type}
                    thirdTitle="Request for approval"
                    category={theQueryParams.category}
                  />
                )}
              </div>
            </div>
            {/*<!-- /Content End -->*/}
          </div>
          {/*<!-- /Page Content -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      <ModalLoader
        show={isSendLoading}
        title={progressData.text || ""}
        progressPercent={progressData.progress}
      />
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
    settings: state.settingsReducer.settings,
    // deductionSettings: state.deductionSettings.deductions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateSalary));
